// extracted by mini-css-extract-plugin
module.exports = {"dialogContent_disabled":"AppFormDialog_dialogContent_disabled__3o6S8","progress_disabled":"AppFormDialog_progress_disabled__298vE"};